import {
  type AdminPostElementTokenResponseBody,
  buildAdminElementTokenRequest,
  parseAdminElementTokenResponse,
} from '@efdigital/ll-admin-v2/data/builders/coaching/admin-cronofy';
import type AppSessionService from '@efdigital/ll-admin-v2/services/session';
import type { CronofyElementType } from '@efdigital/ll-cdk-coaching-cronofy-api-types';
import Service, { service } from '@ember/service';

export default class AdminCronofyService extends Service {
  @service declare session: AppSessionService;

  async getElementToken(
    coachId: string,
    elementType: CronofyElementType,
    origin: string
  ): Promise<AdminPostElementTokenResponseBody> {
    const request = await buildAdminElementTokenRequest(
      this.session,
      coachId,
      elementType,
      origin
    );
    const response = await fetch(request);
    return parseAdminElementTokenResponse(response);
  }
}

declare module '@ember/service' {
  interface Registry {
    'admin-cronofy': AdminCronofyService;
  }
}
